import { createActionTypes } from 'components/utility/actions';
export const types = createActionTypes([
	'FETCH_TRIGGERS',
	'FETCH_TRIGGERS_SUCCESS',
	'FETCH_TRIGGERS_ERROR'
]);

export const fetchTriggers = () => ({ type: types.FETCH_TRIGGERS });
